import { AxiosError, AxiosProgressEvent, AxiosResponse, ResponseType as AxiosResponseType } from "axios";
import jstz from "jstz";
import { UILanguage } from "../../common/enums/UILanguage";
import { IeLynxApiError } from "../../common/models/eLynxApiError";
import UUID from "../../common/utilities/Uuid";
import authService from "../authentication/elynx-auth-service/ELynxAuthService";
import axios from "./axios";
import { sleep } from "../../common/utilities/Sleep";
import { queryClient } from "../query-client-service/QueryClientService";

type RestHeaderParams = {
    unitSetID: string,
    language: string,
    timezone: string,
    //contentType?: string;
    "Content-Type"?: string;
    clientID?: string;
    // _loggerName: string;

    impersonatingUserID: string | undefined;
    impersonatingUserLogin: string | undefined;


};

type RestAuthHeaderParams = {
    authorization: string | undefined;
} & RestHeaderParams;


export class CancelError extends Error { }

class RestService {

    private _headerParameters: RestHeaderParams = {
        unitSetID: "0",
        language:  `${UILanguage.USEnglish}`,
        timezone: jstz.determine().name(),
        clientID: UUID.generate(),
        impersonatingUserID: undefined,
        impersonatingUserLogin: undefined
    };

    public setBaseUrl(url: string) {
        axios.defaults.baseURL = url;
    }

    public setImpersonator(id: number, login: string) {
        this._headerParameters.impersonatingUserID = id.toString();
        this._headerParameters.impersonatingUserLogin = login;
    }
    //    private _baseUrl: string = "";
    //    private _authHeader: { [key: string]: string } | undefined;
    //    private _unitSetID: number | undefined;
    //    private _language: UILanguage = UILanguage.USEnglish;
    //    private _timezone: string = jstz.determine().name();
    //    //private _clientID: string = Utilities.UUID.generate();
    //    private _loggerName: string | undefined;

    //    public set baseUrl(url: string) {
    //        this._baseUrl = url;
    //    }

    //    public get baseUrl(): string {
    //        return this._baseUrl;
    //    }

    // public set authHeader(url: { [key: string]: string }) {
    //     this._authHeader = url;
    // }

    // public get authHeader(): { [key: string]: string } | undefined {
    //     return this._authHeader;
    // }

    // public set unitSetID(id: number) {
    //     this._unitSetID = id;
    // }

    // public get unitSetID(): number {
    //     return this._unitSetID;
    // }

    // public set language(value: UILanguage) {
    //     this._language = value;
    // }

    // public get language(): UILanguage {
    //     return this._language;
    // }

    // public set timezone(value: string) {
    //     this._timezone = value;
    // }

    // public get timezone(): string {
    //     return this._timezone;
    // }

    // public set loggerName(name: string) {
    //     this._loggerName = name;
    // }

    // public get loggerName(): string {
    //     return this._loggerName;
    // }

    // public get clientID(): string {
    //     return this._clientID;
    // }

    // constructor(
    //     /*private _loggerService: Services.ILoggerService,
    //     private _authService: Services.ISCADALynxAuthenticationService*/
    // ) {
    // }

    // private async _getHeaders(): Promise<RestAuthHeaderParams> {
    //     const token = await authService.acquireToken();
    //     return {
    //         ...this._headerParameters,
    //         authorization: token ? "bearer " + token : undefined
    //     };
    // }

    // private inRedirect: boolean = false;
    // private async _redirectToLogin() {
    //     await sleep(3000);
    //     window.location.href = '/login';
    //     this.inRedirect = false;
    // }
    
    private async _getHeaders(): Promise<RestAuthHeaderParams> {
        const token = await authService.acquireToken();

        // // User Story 53377: Research: Missing Authorization Header Errors
        // // token is not set and the current view is not the login view then
        // // redirect to the login view to circumvent flooding the api with calls
        // // that will fail
        // //Bug 53918: Login Redirect Issue try to limit to only one redirect to prevent multiple redirects
        // if (!token && window.location.pathname !== '/login' && window.location.pathname !== '/change-password') {
        //     //debugger;
        //     //window.location.href = '/login';
        //     //throw new CancelError('notoken');
        //     //window.location.reload();
        //     if (!this.inRedirect) {
        //         this.inRedirect = true;

        //         this._redirectToLogin();
                
        //     }
        // }


        // if (!token && window.location.pathname !== '/login' && window.location.pathname !== '/change-password') {
        //     //debugger;
        //     console.log(`canceling ${window.location.pathname}`);
        //     //window.location.href = '/login';
        //     //throw new CancelError('notoken');
        //     //window.location.reload();

        //     queryClient.cancelQueries();
        
        // }



        return {
            ...this._headerParameters,
            //authorization: token ? "bearer " + token : undefined
            authorization: "bearer " + token
        };
    }

    public setHeaderParams(params: RestHeaderParams): void {


        const impersonatingUserID = this._headerParameters.impersonatingUserID;
        const impersonatingUserLogin = this._headerParameters.impersonatingUserLogin;

        this._headerParameters = {...params,
            impersonatingUserID :impersonatingUserID,
            impersonatingUserLogin: impersonatingUserLogin
        };
    }


    public async get<TReturnType>(path: string, signal?: AbortSignal): Promise<AxiosResponse<TReturnType>>;
    public async get<TReturnType, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType): Promise<AxiosResponse<TReturnType>>;
    public async get<TReturnType, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType, responseType?: ResponseType): Promise<AxiosResponse<TReturnType>>;
    public async get<TReturnType, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType, responseType?: ResponseType): Promise<AxiosResponse<TReturnType>> {
    //public async get<T, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType, bypassLogger = false, timeout: number | undefined = undefined): Promise<AxiosResponse<T>> {

        try {
            //console.log(`TODO: byPassLogger ${bypassLogger}, timeout ${timeout}`);
            
            const headers = await this._getHeaders();
            const response = await axios.get<TReturnType>(path, {
                headers: headers as Record<string, string>,
                signal: signal,
                params: queryParams,
                responseType: responseType
            });

            return response;

        } catch (error) {
            if (axios.isCancel(error)) {
                throw new CancelError('cancel');
            }

            //@@wonder if we can config axios to call generic error handler
            throw error;
        }


    }

    // HTTP PUT
    public async put<TEntityType, TReturnType>(path: string, entity: TEntityType, signal?: AbortSignal): Promise<AxiosResponse<TReturnType>>;
    public async put<TEntityType, TParamsType, TReturnType>(path: string, entity: TEntityType, signal?: AbortSignal, queryParams?: TParamsType): Promise<AxiosResponse<TReturnType>>;
    public async put<TEntityType, TParamsType, TReturnType>(path: string, entity: TEntityType, signal?: AbortSignal, queryParams?: TParamsType, bypassLogger = false): Promise<AxiosResponse<TReturnType>> {

        try {
            //console.log(`TODO: bypassLogger ${bypassLogger}`);

            const headers = await this._getHeaders();
            const response = await axios.put<TEntityType, AxiosResponse<TReturnType>>(path,
                entity,
                {
                    headers: headers as Record<string, string>,
                    signal: signal,
                    params: queryParams
                });

            return response;

        } catch (error) {
            if (axios.isCancel(error)) {
                throw new CancelError('cancel');
            }

            throw error;
        }


        // var request = {
        //     method: "PUT",
        //     path: path,
        //     params: queryParams,
        //     entity: entity
        // };

        // return this._sendHttpRequest<TEntityType, TParamsType>(request, null, bypassLogger);
    }

    public async post<TEntityType, TReturnType>(path: string, entity: TEntityType, signal?: AbortSignal): Promise<AxiosResponse<TReturnType>>;
    public async post<TEntityType, TReturnType>(path: string, entity: TEntityType, signal?: AbortSignal, mimeType?: string): Promise<AxiosResponse<TReturnType>>;
    public async post<TEntityType, TReturnType, TParamsType>(path: string, entity: TEntityType, signal?: AbortSignal, mimeType?: string, queryParams?: TParamsType): Promise<AxiosResponse<TReturnType>>;
    public async post<TEntityType, TReturnType, TParamsType>(path: string, entity: TEntityType, signal?: AbortSignal, mimeType?: string, queryParams?: TParamsType, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void): Promise<AxiosResponse<TReturnType>>;
    public async post<TEntityType, TReturnType, TParamsType>(path: string, entity: TEntityType, signal?: AbortSignal, mimeType?: string, queryParams?: TParamsType, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void, bypassLogger?: boolean): Promise<AxiosResponse<TReturnType>> {

        try {
            //console.log(`TODO: bypassLogger ${bypassLogger}`);

            const headers = await this._getHeaders();
            if (mimeType) {
                // headers.contentType = mimeType;
                headers["Content-Type"] = mimeType;
            }
            const response = await axios.post<TEntityType, AxiosResponse<TReturnType>>(path,
                entity,
                {
                    headers: headers as Record<string, string>,
                    signal: signal,
                    params: queryParams,
                    //responseType: mimeType
                    onUploadProgress: (progressEvent: AxiosProgressEvent) => onUploadProgress && onUploadProgress(progressEvent)
                });

            return response;

        } catch (error) {
            if (axios.isCancel(error)) {
                throw new CancelError('cancel');
            }

            throw error;
        }
    }


    public async delete<TEntityType>(path: string, signal?: AbortSignal): Promise<AxiosResponse<TEntityType>>;
    public async delete<TEntityType, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType): Promise<AxiosResponse<TEntityType>>;
    public async delete<TEntityType, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType, entity?: TEntityType): Promise<AxiosResponse<TEntityType>>;
    public async delete<TEntityType, TParamsType>(path: string, signal?: AbortSignal, queryParams?: TParamsType, entity?: TEntityType, bypassLogger = false): Promise<AxiosResponse<TEntityType>> {

        try {
            //console.log(`TODO: bypassLogger ${bypassLogger}`);

            const headers = await this._getHeaders();
            const response = await axios.delete<TEntityType, AxiosResponse<TEntityType>>(path, {
                headers: headers as Record<string, string>,
                params: queryParams,
                data: entity,
                signal: signal
                //responseType: mimeType
            });

            return response;

        } catch (error) {
            if (axios.isCancel(error)) {
                throw new CancelError('cancel');
            }

            throw error;
        }

        //     var request = {
        //         method: "DELETE",
        //         path: path,
        //         params: queryParams,
        //         entity: entity
        //     };

        //     return this._sendHttpRequest<TEntityType, TParamsType>(request, null, bypassLogger);
    }


    // private _checkForUnauthorized(response: rest.Response): boolean {
    //     var ret: boolean = false;
    //     if (response.status && response.status.code == 401) {
    //         //cannot do this!  need error information for user.
    //         //this._authService.login();
    //         //var err: IAuthenticationErrorResponse = <IAuthenticationErrorResponse>JSON.parse(response.entity);

    //         var apiError: Models.IeLynxAPIError =  {
    //             errorCode: Enums.AuthenticationResultEnum[Enums.AuthenticationResultEnum.TokenExpired],
    //             exceptionMessage: null,
    //             exceptionType: null,
    //             logReference: null,
    //             message: response.entity.message,
    //             showDetail: true
    //         }

    //         // need to call the error handler that does not try and call user activity log
    //         this._loggerService.logger("login")
    //             .error(apiError);

    //         ret = true;
    //     }

    //     return ret;
    // }

    // private _sendHttpRequest<TEntityType, TParamsType>(request: any, mimeType?: string, bypassLogger: boolean = false, timeout: number = null): Services.RestPromise<Services.IRestResponse<TEntityType>> {

    //     var promise = when.promise<Services.IRestResponse<TEntityType>>((
    //         resolve: (value: Services.IRestResponse<TEntityType>) => void,
    //         reject: (reason: Services.IRestResponse<TEntityType>) => void) => {

    //         //acquire the bearer token
    //         this._authService.acquireToken()
    //             .then<Services.IRestResponse<TEntityType>>((token: string): any => {

    //                 request.headers = this._getHeader(token);

    //                 // wrap query parameter dates or moments with ISODateSerializer class
    //                 if (request.params) {
    //                     for (var param in request.params) {
    //                         if (request.params.hasOwnProperty(param) && request.params[param] && typeof request.params[param].toISOString === "function") {
    //                             request.params[param] = new Utilities.ISODateSerializer(request.params[param]);
    //                         }
    //                         //request.path = `${request.path}{?${Object.keys(request.params).join(",")}}`;
    //                     }
    //                 }

    //                 var client: rest.Client =
    //                     rest.wrap<any>(mimeFix)
    //                         .wrap<restMime.Config>(restMime, { mime: mimeType ? mimeType : "application/json" })
    //                         .wrap<restPathPrefix.Config>(restPathPrefix, { prefix: this._baseUrl })
    //                         .wrap<restErrorCode.Config>(restErrorCode)
    //                         .wrap<restParams.Config>(restParams);
    //                         //.wrap<restTemplate.Config>(restTemplate);

    //                 if (timeout) {
    //                     // If transient is not set to false then an error is not thrown and our code cannot control the retries.
    //                     client = client.wrap<restTimeout.Config>(restTimeout, { timeout: timeout, transient: false });
    //                 }

    //                 if (!bypassLogger) {
    //                     client = client.wrap<restLogger.Config>(restLogger, { loggerService: this._loggerService, loggerName: this._loggerName });
    //                 }

    //                 client(request)
    //                     .then((data: rest.Response) => {
    //                         resolve(new Services.RestResponse<TEntityType>(new Services.RestStatus(data.status.code, data.status.text), data.entity));
    //                     })
    //                     .catch((data: rest.Response) => {

    //                         if ((<any>data).error && (<any>data).error.toLowerCase() === "timeout" && (<any>data.request).canceled) {
    //                             reject(new Services.RestResponse<TEntityType>(new Services.RestStatus(0, (<any>data).error), null));
    //                         }
    //                         else if ((<any>data.request).canceled) {
    //                             reject(new Services.RestResponse<TEntityType>(new Services.RestStatus(0, "canceled"), null));
    //                         } else if (!this._checkForUnauthorized(data)) {
    //                             reject(new Services.RestResponse<TEntityType>(new Services.RestStatus(data.status.code, data.status.text), data.entity));
    //                         };
    //                     });
    //             });
    //     });

    //     // Convert the promise to be returned into a RestPromise, which can be canceled.
    //     return _makeRestPromise(request, promise);
    // }
}

// function _makeRestPromise<T>(request: any, promise: When.Promise<T>): Services.RestPromise<T> {
//     var _promise = (<any>promise);
//     _promise._request = request;
//     _promise.cancel = function () {
//         if (this._request) {
//             if (this._request.cancel) {
//                 this._request.cancel();
//             } else {
//                 this._request.canceled = true;
//             }
//         }
//     }
//     _promise.then = function (onFulfilled, onRejected, onProgress) {
//         return _makeRestPromise(this._request, _promise.__proto__.then.call(this, onFulfilled, onRejected, onProgress));
//     }

//     //catch() and finally() both call then() internally, so the returned promise is already a RestPromise.
//     //this is good because overriding catch() as below causes "Potentially unhandled rejection" errors.

//     //_promise.catch = function (arg1, arg2) {
//     //    return _extendPromise(this._request, _promise.__proto__.catch.call(this, arg1, arg2));
//     //}
//     //_promise.finally = function (onFulfilledOrRejected: Function) {
//     //    return _extendPromise(this._request, _promise.__proto__.finally.call(this, onFulfilledOrRejected));
//     //}

//     return <Services.RestPromise<T>> promise;
// }

// var restLogger: rest.Interceptor<restLogger.Config> = interceptor({
//     success(response: rest.Response, config: restLogger.Config, meta: any) {
//         return response;
//     },
//     error(response: rest.Response, config: restLogger.Config, meta: any) {

//         //if (response.status.code < 500) {
//         //    config.loggerService.logger(config.loggerName).warn(response.entity);
//         //}

//         //if (response.status.code >= 500) {
//         //    config.loggerService.logger(config.loggerName).error(response.entity);
//         //}

//         return when.reject<rest.Response>(response);

//     }
// });

// module restLogger {
//     export interface Config {
//         loggerService: Services.ILoggerService;
//         loggerName: string;
//     }
// }

// var mimeFix: rest.Interceptor<any> = interceptor({
//     request: function (request, config) {
//         if (!request.entity || request.entity === "undefined" || request.entity === "null") {
//             request.entity = null;
//             delete request.headers["Content-Type"];
//         }
//         return request;
//     }
// });

const restService = new RestService();
//module.exports.default = storageService;
export default restService;

export type RestError = AxiosError<IeLynxApiError> & {
    offline?: boolean;
};

export type ResponseType = AxiosResponseType;